module.exports = __webpack_public_path__ + "static/media/cq_calendario_grigio.98ead508.svg";